import axios from "axios";
import { get } from "lodash";
import { toastr } from "react-redux-toastr";
import { Group } from "../../utils/logger";
import {
  BIDGELY_REPORT_LOADING,
  BIDGELY_SUBTYPE_LOADING,
  BIDGELY_TYPE_LOADING,
  BIDGELY_CLICK_REPORT_LOADING,
  BIDGELY_DEVICE_REPORT_LOADING,
  BIDGELY_PLATFORM_SUMMARY_REPORT_LOADING,
  BIDGELY_DOWNLOAD_REPORT_LOADING,
  SET_BIDGELY_TYPES,
  SET_BIDGELY_SUBTYPES,
  SET_BIDGELY_STATS,
  RESET_BIDGELY_REPORTS,
  ADD_BIDGELY_REPORT_ERROR,
  SET_BIDGELY_CLICK_TABLE,
  SET_BIDGELY_PLATFORMSUMMARY_TABLE,
  USER_TOKEN_NAME,
  BIDGELY_REPORT_DOWNLOADED,
  SET_BIDGELY_DEVICE,
} from "../constants";

import { isLocal } from "../../utils/env";

const Logger = new Group("Bidgely Actions", { disable: true });

export const RESULT_SESSION_TOKEN = "amrnResultOptions";

export const addError = (error, name) => (dispatch) => {
  dispatch({ type: ADD_BIDGELY_REPORT_ERROR, payload: error, name });
};

// ============================================================================
// Get Options ================================================================
// ============================================================================

export const getTypeOptions = (options) => (dispatch) => {
  Logger.emit(`Getting report typeOptions`);

  dispatch({ type: BIDGELY_TYPE_LOADING, payload: "types" });

  return axios
    .post(`reports/bidgely/types`, options)
    .then((res) => {
      const payload = get(res, "data.types");

      payload && dispatch({ type: SET_BIDGELY_TYPES, payload });

      return payload;
    })
    .catch((error) => {
      Logger.emit("Error getting types", { error });
      toastr.error("Error", "There was a problem getting 'type' options. Please try again later");
      dispatch(addError(error, "types"));
    });
};

export const getSubTypeOptions = (options) => (dispatch) => {
  Logger.emit(`Getting report subTypeOptions`);

  dispatch({ type: BIDGELY_SUBTYPE_LOADING, payload: "subTypes" });

  return axios
    .post(`reports/results/sub-types`, options)
    .then((res) => {
      const payload = get(res, "data.sub_types");

      payload && dispatch({ type: SET_BIDGELY_SUBTYPES, payload });

      return payload;
    })
    .catch((error) => {
      Logger.emit("Error getting sub-types", { error });
      toastr.error(
        "Error",
        "There was a problem getting 'sub-type' options. Please try again later"
      );
      dispatch(addError(error, "subTypes"));
    });
};

// ============================================================================
// Get Data ===================================================================
// ============================================================================

export const getCountsByResult = (options) => (dispatch) => {
  Logger.emit(`Getting report stats with options`, options);

  dispatch({ type: BIDGELY_REPORT_LOADING, payload: "stats" });

  return axios
    .post(`reports/bidgely/stats`, options)
    .then((res) => {
      const payload = get(res, "data.stats");

      dispatch({ type: SET_BIDGELY_STATS, payload });

      return payload;
    })
    .catch((error) => {
      Logger.emit("Error getting report", { error: error });
      dispatch(addError(error, "stats"));
    });
};

export const getClickResults = (tableProps) => (dispatch) => {
  Logger.emit(`Getting bidgely click report with options`, tableProps);

  dispatch({ type: BIDGELY_CLICK_REPORT_LOADING, payload: "clicks" });

  return axios
    .post(`reports/bidgely/click`, tableProps)
    .then((res) => {
      const payload = get(res, "data.clickResult");

      dispatch({ type: SET_BIDGELY_CLICK_TABLE, payload });
      return payload;
    })
    .catch((error) => {
      Logger.emit("Error getting report", { error: error });
      dispatch(addError(error, "clicks"));
    });
};

export const getPlatformSummaryResults = (tableProps) => (dispatch) => {
  Logger.emit(`Getting bidgely click report with options`, tableProps);
  dispatch({ type: BIDGELY_PLATFORM_SUMMARY_REPORT_LOADING, payload: "summary" });

  return axios
    .post(`reports/bidgely/platformsummary`, tableProps)
    .then((res) => {
      const payload = get(res, "data.clickResult");

      dispatch({ type: SET_BIDGELY_PLATFORMSUMMARY_TABLE, payload });

      return payload;
    })
    .catch((error) => {
      Logger.emit("Error getting report", { error: error });
      dispatch(addError(error, "summary"));
    });
};

export const getDeviceByResult = (options) => (dispatch) => {
  Logger.emit(`Getting report device with options`, options);

  dispatch({ type: BIDGELY_DEVICE_REPORT_LOADING, payload: "device" });

  return axios
    .post(`reports/bidgely/device`, options)
    .then((res) => {
      const payload = get(res, "data.deviceResult.data");
      dispatch({ type: SET_BIDGELY_DEVICE, payload });

      return payload;
    })
    .catch((error) => {
      Logger.emit("Error getting report", { error: error });
      dispatch(addError(error, "device"));
    });
};

export const downloadreport = (options) => (dispatch) => {
  Logger.emit(`Getting report device with options`, options);

  dispatch({ type: BIDGELY_DOWNLOAD_REPORT_LOADING, payload: "bidgely_download" });

  const domain = isLocal()
    ? `http://localhost:8000/api/v1`
    : `${window.location.protocol === "https:" ? "https://" : "http://"}${
        window.location.hostname
      }/api/v1`;

  let token = localStorage.getItem(USER_TOKEN_NAME);
  let url = new URL(`${domain}/reports/bidgely/reportdownload`);

  Object.keys(options).forEach((key) =>
    url.searchParams.append(
      key,
      typeof options[key] === "string" ? options[key] : JSON.stringify(options[key])
    )
  );

  fetch(url, {
    method: "GET",
    headers: new Headers({
      Authorization: "Bearer " + token,
    }),
  })
    .then((response) => response.blob())
    .then((blob) => {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      a.download = "bidgely-report.csv";
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox

      dispatch({ type: BIDGELY_REPORT_DOWNLOADED, payload: {} });

      a.click();
      a.remove(); //afterwards we remove the element again
    });
};

//reset landing reducer state
export const resetState = () => ({ type: RESET_BIDGELY_REPORTS });
